import { useCallback } from 'react'
import { JP } from '../constants'
import { useAppContext } from '../contexts/app-context'

export const useHelper = () => {
  const { reqContextData, pageProps } = useAppContext()

  const generateLinkWithCoBrand = useCallback(
    (link) => {
      if (reqContextData.coBrand) {
        return `/${reqContextData.coBrand}${link}`
      }
      return link
    },
    [reqContextData],
  )

  const isLoggedIn = useCallback(() => {
    return reqContextData.isLoggedIn
  }, [reqContextData])

  const getPageName = useCallback(() => {
    return pageProps.pageName
  }, [pageProps])

  const getDisplayName = useCallback(() => {
    const { user, country } = reqContextData
    if (user && typeof user === 'object') {
      if (country === JP) {
        return user.lastName || ''
      }
      return user.firstName || ''
    }
    return ''
  }, [reqContextData])

  return { generateLinkWithCoBrand, isLoggedIn, getDisplayName, getPageName }
}
